/**
 * An info icon beside a drawer button whose help would otherwise be a paragraph
 * under it (Pete, 2026-10-12: help text into tooltips).
 */
import { IconButton, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export function HelpTip({ label, text }: { label: string; text: string }) {
  return (
    <Tooltip title={text} placement="bottom-end">
      <IconButton size="small" aria-label={`About ${label}`} sx={{ color: "text.secondary" }}>
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
